import { render, staticRenderFns } from "./ProductItemForm.vue?vue&type=template&id=7d87868f"
import script from "./ProductItemForm.vue?vue&type=script&lang=js"
export * from "./ProductItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports